<template>
  <div>
    <el-aside class="sidebar" width="216px">
      <el-menu
        :default-active="pageActive"
        class="el-menu-vertical-demo">
        <el-menu-item index="1" @click="toPage('')">
          <i class="index"></i>
          <span slot="title">{{ global.type == 'manage' ? '工作台' : '首页' }}</span>
        </el-menu-item>
        <el-menu-item index="2" @click="toPage('/workblank')">
          <i class="image"></i>
          <span slot="title">上传底图</span>
        </el-menu-item>
        <el-menu-item index="3" @click="toPage('/effectsave')">
          <i class="edit"></i>
          <span slot="title">生成效果图</span>
        </el-menu-item>
        <el-menu-item index="4" @click="toPage('/effectaiedit')">
          <i class="ai_edit"></i>
          <span slot="title">AI改图</span>
        </el-menu-item>
        <el-menu-item index="5" @click="toPage('/effectvideo')">
          <i class="img_video"></i>
          <span slot="title">图生视频</span>
        </el-menu-item>
        <el-menu-item index="6" @click="toPage('/effecthistory')" v-if="global.type == 'manage'">
          <i class="image"></i>
          <span slot="title">效果生成历史</span>
        </el-menu-item>
        <el-menu-item index="7" @click="toPage('/material')" v-if="global.type == 'manage'">
          <i class="material"></i>
          <span slot="title">素材库</span>
        </el-menu-item>
        <el-menu-item index="8" @click="toPage('/materialperson')" v-if="global.type == 'manage'">
          <i class="material_person"></i>
          <span slot="title">个人素材库</span>
        </el-menu-item>
        <el-menu-item index="9" @click="toPage('/customerdetail')" v-if="global.type == 'client'">
          <i class="image"></i>
          <span slot="title">效果生成历史</span>
        </el-menu-item>
      </el-menu>
      <div class="change" @click="toChange"><i></i><span>{{global.type == 'manage' ? '管理端' : '客户端' }}（当前）</span></div>
    </el-aside>
  </div>
</template>
  
<script>

export default {
  name: 'SideBarComponent',
  data() {
    return {
      pageActive: 0,
      nowPage: ''
    }
  },
  watch: {
    '$route': {
      handler(to, from) {
        console.log('路由变化:', to.path);
        let _path = to.path
        _path = _path.replace(/^\/+/, "");
        if(_path.includes('/')){
          let _pathArray = _path.split('/')
          _path = _pathArray[0]
        }
        this.nowPage = _path
        console.log('path', _path, from)
        switch (_path) {
          case "":
            console.log('');
            this.pageActive = "1"
            break;
          case "client":
            console.log('client');
            this.pageActive = "1"
            break;
          case "customernew":
            console.log('customernew');
            this.pageActive = "1"
            break;
          case "customerhistory":
            console.log('customerhistory');
            this.pageActive = "1"
            break;
          case "customerhistorydetail":
            console.log('customerhistorydetail');
            this.pageActive = "1"
            break;
          case "workblank":
            console.log('workblank');
            this.pageActive = "2"
            break;
          case "effectsave":
            console.log('effectsave');
            this.pageActive = "3"
            break;
          case "effectaiedit":
            console.log('effectaiedit');
            this.pageActive = "4"
            break;
          case "effectvideo":
            console.log('effectvideo');
            this.pageActive = "5"
            break;
          case "effecthistory":
            console.log('effecthistory');
            // if(this.global.type == 'manage'){
            //   this.pageActive = "6"
            // }
            // if(this.global.type == 'client'){
            //   this.pageActive = "9"
            // }
            this.pageActive = "6"
            break;
          case "effectcollect":
            console.log('effectcollect');
            this.pageActive = "6"
            break;
          case "material":
            console.log('material');
            this.pageActive = "7"
            break;
          case "materialperson":
            console.log('materialperson');
            this.pageActive = "8"
            break;
          case "customerdetail":
            console.log('customerdetail');
            if(this.global.type == 'manage'){
              this.pageActive = "1"
            }
            if(this.global.type == 'client'){
              this.pageActive = "9"
            }
            break;
        }
      },
      immediate: true,  // 立即触发一次
      deep: true        // 深度监听
    }
  },
  methods: {
    toPage(pageName) {
      let _page = pageName
      console.log('join',_page, this.nowPage)
      if(pageName == ""){
        _page = '/'
        if(this.global.type == 'client'){
          _page = '/client'
        }
      }
      if(_page == '/'+this.nowPage) return
      if(pageName == "/customerdetail"){
        _page = pageName + '/' + this.global.clientId
      }
      this.$router.push(_page)
    },
    beforeRouteUpdate(to, from, next) {
      console.log('组件内路由切换检测:', to.path);
      next();
    },
    toChange() {
      this.$router.push('/login')
    }
  }
}
</script>
  
<style scoped lang="less">
.sidebar {
  background: #fff;
  overflow: hidden;
  .el-menu {
    height: calc(100vh - 110px);
    border: 0;
    .el-menu-item {
      position: relative;
      height: 64px;
      margin-bottom: 8px;
      padding-left: 72px !important;
      padding-top: 17px;
      padding-bottom: 17px;
      border-radius: 0 20px 20px 0;
      color: rgba(102,102,102,1);
      font-size: 18px;
      line-height: 30px;
      font-weight: normal;
      i {
        position: absolute;
        top: 50%;
        left: 40px;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        &.index {
          background-image: url(../assets/ico_index.png);
        }
        &.image {
          background-image: url(../assets/ico_img.png);
        }
        &.edit {
          background-image: url(../assets/ico_edit.png);
        }
        &.ai_edit {
          background-image: url(../assets/ico_ai_edit.png);
        }
        &.img_video {
          background-image: url(../assets/ico_img_video.png);
        }
        &.material {
          background-image: url(../assets/ico_material.png);
        }
        &.material_person {
          background-image: url(../assets/ico_material_person.png);
        }
      }
      &.is-active {
        background: rgb(80, 184, 92);
        color: #fff;
        i {
          &.index {
            background-image: url(../assets/ico_index_on.png);
          }
          &.image {
            background-image: url(../assets/ico_img_on.png);
          }
          &.edit {
            background-image: url(../assets/ico_edit_on.png);
          }
          &.ai_edit {
            background-image: url(../assets/ico_ai_edit_on.png);
          }
          &.img_video {
            background-image: url(../assets/ico_img_video_on.png);
          }
          &.material {
            background-image: url(../assets/ico_material_on.png);
          }
          &.material_person {
            background-image: url(../assets/ico_material_person_on.png);
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .change {
    height: 40px;
    color: rgba(79,79,79,1);
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    vertical-align: top;
    i {
      display: inline-block;
      width: 16px;
      height: 38px;
      background: url(../assets/ico_change.png) no-repeat;
      background-size: contain;
      background-position: 0 center;
    }
    span {
      display: inline-block;
      height: 40px;
      margin-left: 6px;
      vertical-align: top;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SideBarComponent.vue